import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
    selector: 'app-select-language',
    templateUrl: './select-language.component.html',
    styleUrl: './select-language.component.scss',
    standalone: false
})
export class SelectLanguageComponent {
  selectedLang: string = 'EN';
  langList: Array<any> = [
    { key: 'EN', value: 'English' },
    { key: 'TR', value: 'Türkçe' },
    { key: 'ES', value: 'Español' },
  ];
  lang: string = 'en';
  listOpen: boolean = false;
  chosenLang: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.chosenLang = this.activatedRoute.snapshot.queryParams['lang'];
    if (this.chosenLang) {
      this.storageService.Set('lang', this.chosenLang);
    } else {
      if (this.storageService.Get('lang')) {
        this.lang = this.storageService.Get('lang');
        this.selectedLang = this.lang.toUpperCase();
        this.translate.use(this.lang);
      } else {
        this.storageService.Set('lang', this.lang);
        this.lang = this.lang.toUpperCase();
        this.translate.use(this.lang);
      }
    }
  }

  openLangOpt() {
    this.listOpen = !this.listOpen;
  }

  setLang(lang: string) {
    this.listOpen = false;
    this.selectedLang = this.langList.filter((e) => e.value == lang)[0].key;
    this.storageService.Set('lang', this.selectedLang.toLowerCase());
    this.translate.use(this.selectedLang.toLowerCase());
  }
}
